import Chip from "@mui/material/Chip"
import { lighten, styled, useTheme } from "@mui/material/styles"

import { NumberTableCell } from "../../../common/components/tables/cells"

export default function LikelihoodToMoveTableCell({ row }) {
  const { label } = useTranslateLikelihoodToMove(row.likelihood_to_move)
  return (
    <NumberTableCell>
      {row.likelihood_to_move !== null && (
        <LikelihoodToMoveChip score={row.likelihood_to_move} label={label} />
      )}
    </NumberTableCell>
  )
}

export function useTranslateLikelihoodToMove(likelihoodToMove: Number) {
  const theme = useTheme()
  return translateLikelihoodToMove(likelihoodToMove, theme)
}

function translateLikelihoodToMove(likelihoodToMove: Number, theme) {
  let label, color
  const neutralColor = (color = theme.palette.grey[300])
  if (likelihoodToMove === null) {
    label = "Unknown"
    color = neutralColor
  } else if (likelihoodToMove >= 80) {
    label = "Excellent"
    color = theme.palette.success.main
  } else if (likelihoodToMove >= 60) {
    label = "Great"
    color = theme.palette.success.light
  } else if (likelihoodToMove >= 40) {
    label = "Good"
    color = neutralColor
  } else if (likelihoodToMove >= 20) {
    label = "Fair"
    color = theme.palette.warning.light
  } else {
    label = "Slim"
    color = theme.palette.warning.main
  }

  return {
    label,
    color: lighten(color, 0.5),
  }
}

export const LikelihoodToMoveChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "score",
})(({ theme, score }) => ({
  backgroundColor: translateLikelihoodToMove(score, theme).color,
  fontWeight: 500,
  minWidth: "80px",
  height: "28px",
  fontSize: "0.875rem",
}))
